import React from "react";
import { Stack, Text, Button, Alert } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";

export interface DisplayLinkErrorProps {
  /** Error message to display */
  message: string;

  /** Optional title for the error */
  title?: string;

  /** Optional action button text */
  actionText?: string;

  /** Optional action button handler */
  onAction?: () => void;
}

export const DisplayLinkError: React.FC<DisplayLinkErrorProps> = ({
  message,
  title = "Error",
  actionText,
  onAction,
}) => {
  return (
    <Stack align="center" gap="lg" style={{ maxWidth: 500, margin: "0 auto" }}>
      <Alert
        icon={<IconAlertCircle size="1rem" />}
        title={title}
        color="red"
        variant="light"
        style={{ width: "100%" }}
      >
        <Text size="sm">{message}</Text>
      </Alert>

      {actionText && onAction && (
        <Button onClick={onAction} variant="outline" color="red">
          {actionText}
        </Button>
      )}
    </Stack>
  );
};
